import getBranches from '@/api/branches/getBranches'
import saveBranch from '@/api/branches/saveBranch'
import deleteBranch from '@/api/branches/deleteBranch'

const state = {
  branches: [],
  currentBranch: {},
}

const actions = {
  getBranchesAction({ commit }) {
    return new Promise((resolve, reject) => {
      getBranches
        .call(this)
        .then(response => {
          if (response.status == 'OK') {
            commit('setBranchesMutation', {
              branches: response.data,
              meta: response.meta,
            })
            resolve()
          } else {
            reject(new Error(response.message))
          }
        })
        .catch(e => {
          reject(new Error(e))
        })
    })
  },
  saveBranchAction({ commit }, { branch }) {
    return new Promise((resolve, reject) => {
      saveBranch
        .call(this, { branches: [branch] })
        .then(response => {
          if (response.status == 'OK') {
            commit('updateBranchMutation', { branches: response.data })
            resolve()
          } else {
            reject(new Error(response.message))
          }
        })
        .catch(e => {
          reject(new Error(e))
        })
    })
  },
  deleteBranchAction({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteBranch
          .call(this, id)
          .then(response => {
            if (response.status == 'OK') {
              commit('deleteBranchMutation', { branch: response.data })
              resolve()
            } else {
              reject(new Error(response.message))
            }
          })
          .catch(e => {
            reject(new Error(e))
          })
      })
    },
  
}

const mutations = {
  setBranchesMutation(state, { branches }) {
    state.branches = branches
  },
  updateBranchMutation(state, { branches }) {
    branches.forEach(branch => {
      const index = state.branches.findIndex(r => r.id == branch.id)
      if (typeof index !== 'undefined') {
        state.branches.splice(index, 1, branch)
      } else {
        state.branches.push(branch)
      }
    })
  },
  deleteBranchMutation(state, { branch }) {
    const index = state.branches.findIndex(r => r.id == branch.id)
    if (typeof index !== 'undefined') {
      state.branches.splice(index, 1)
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
